import { archiveCaseOpen, refuseCaseOpen, selectCase, assignUserOpen, setInProgressState } from '../../store/case';

import { ApplicationState } from '../../store';
import { BelfiusText } from '../custom';
import { CaseResponse, CaseSearch } from '../../store/case/model';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import { Link } from 'react-router';
import React from 'react';
import { connect } from 'react-redux';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './case-details.module.css';
import { Role } from '../../store/shared/model';
import { PolicySubTypeTCEnum } from '../../store/details/policy/types';
import { BelfiusTooltip } from '../custom/belfius-tooltip';
import { Dispatch } from 'redux';

interface PropsFromState {
  readonly offlineCases: CaseResponse[];
  readonly currentLanguage: string;
  readonly roles: string[];
  readonly caseSearch: CaseSearch;
}
interface ICaseProps {
  readonly case: CaseResponse;
}

interface PropsFromDispatch {
  readonly selectCase: typeof selectCase;
  readonly refuseCaseOpen: typeof refuseCaseOpen;
  readonly archiveCaseOpen: typeof archiveCaseOpen;
  readonly assignUserOpen: typeof assignUserOpen;
  readonly setInProgressState: typeof setInProgressState;
}

type AllProps = ICaseProps & PropsFromDispatch & PropsFromState

class CaseDetails extends React.Component<AllProps> {
  private localization: Ii18n;
  private caseDetailsLink: any;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  getCaseCodeLinkStyle() {
    const style = this.props.case.isRead ? styles.link : styles.linkNotRead;

    return style;
  }

  getInsuranceLogoIcon() {
    switch (this.props.case.policySubTypeTC) {
      case PolicySubTypeTCEnum.BELFIUS_HOME:
        return <img alt="" src={require('../../assets/images/belfius_logo_218x46.png')} className={styles.policyTypeIcon} />;
      case PolicySubTypeTCEnum.DVV_BRAND:
        if (this.props.case.policyHolderLanguageTC === 'nl-BE') {
          return <img alt="" src={require('../../assets/images/dvv_nl.png')} className={styles.policyTypeIcon} />;
        } else {
          return <img alt="" src={require('../../assets/images/dvv_fr.png')} className={styles.policyTypeIcon} />;
        }
      default:
        return '';
    }
  }

  renderAddressData() {
    let riskAddressData = `${this.props.case.riskCity} ${this.props.case.riskStreet} ${this.props.case.riskBuildingNumber}`;
    const busNumber = `${this.props.case.riskBoxNumber}`;
    let phone = `${this.props.case.telephone}`;
    let mobile = `${this.props.case.mobile}`;
    if (busNumber !== `null` && busNumber !== `?`) {
      riskAddressData += ` ` + busNumber;
    }
    if (mobile !== `null` && mobile !== `?` && mobile !== `undefined`) {
      mobile = mobile.replace(' ', '/');
      riskAddressData += `, ` + mobile.replace(/[/]+/g, '/').replace(/\s/g, '');
    } else if (phone !== `null` && phone !== `?` && phone !== `undefined`) {
      phone = phone.replace(' ', '/').replace(/[/]+/g, '/').replace(/\s/g, '');
      riskAddressData += `, ` + phone;
    }

    let insuredAddressData = `${this.props.case.policyHolderCity} ${this.props.case.policyHolderStreet} ${this.props.case.policyHolderBuildingNumber}`;
    const insuredBusNumber = `${this.props.case.policyHolderBoxNumber}`;

    if (insuredBusNumber !== `null` && insuredBusNumber !== `?`) {
      insuredAddressData += ` ` + insuredBusNumber;
    }
    if (mobile !== `null` && mobile !== `?` && mobile !== `undefined`) {
      mobile = mobile.replace(' ', '/');
      insuredAddressData += `, ` + mobile.replace(/[/]+/g, '/').replace(/\s/g, '');
    } else if (phone !== `null` && phone !== `?` && phone !== `undefined`) {
      phone = phone.replace(' ', '/').replace(/[/]+/g, '/').replace(/\s/g, '');
      insuredAddressData += `, ` + phone;
    }

    // no Insured address or Insured address is the same as risk address
    if (this.props.case.addressId === null ||
      (this.props.case.riskCity === this.props.case.policyHolderCity &&
        this.props.case.riskStreet === this.props.case.policyHolderStreet &&
        this.props.case.riskBuildingNumber === this.props.case.policyHolderBuildingNumber)) { return <BelfiusText>{riskAddressData}</BelfiusText>; }

    return (<div>
      <BelfiusText>{riskAddressData}</BelfiusText><br />
      <BelfiusText>{insuredAddressData}</BelfiusText>
    </div>);
  }

  navigateToCaseDetails = (evnt: any) => {
    if (evnt.target.className.indexOf('actionRow') === -1 && evnt.target.className.indexOf('actionIcon') === -1) { this.caseDetailsLink.click(); }
  }

  render() {
    return (
      <div className={styles.container} onClick={(evnt: any) => this.navigateToCaseDetails(evnt)}>
        <div className={styles.firstColumnWrapper}>
          <div className={styles.damageType}>
            <BelfiusTooltip title={this.localization.get(`home.${this.props.case.damageIcon}.tooltip`)}>
              <img alt="" src={require('../../assets/images/' + this.props.case.damageIcon + '_75x75.png')} className={styles.damageTypeIcon} />
            </BelfiusTooltip>
            <div className={styles.insuranceLogo}>
              {this.getInsuranceLogoIcon()}
            </div>
          </div>
          <div className={`${styles.text} ${styles.caseCode}`}>
            <Link
              ref={(ref: any) => (this.caseDetailsLink = ref)}
              to={`/details/${this.props.case.instructionId}/#insured_person`}
              onClick={() => this.props.selectCase(this.props.case)}
              className={this.getCaseCodeLinkStyle()}>
              <BelfiusText>{this.props.case.caseCode}</BelfiusText>
            </Link>
          </div>
        </div>
        <div className={`${styles.text} ${styles.insuredPersonName}`}>
          <BelfiusText>{this.props.case.insuredPersonName}</BelfiusText>
        </div>
        <div className={`${styles.text} ${styles.insuredPersonData}`}>
          {this.renderAddressData()}
        </div>
        <div className={`${styles.text} ${styles.zipCode}`}>
          <BelfiusText>
            {this.props.case.riskZipCode}
          </BelfiusText>
        </div>
        <div className={`${styles.text} ${styles.receivedDate}`}>
          <BelfiusText>{
            this.props.case.createdOn !== undefined
            ? this.localization.getFormatedDateTime(
                typeof this.props.case.createdOn === 'string'
                  ? new Date(this.props.case.createdOn) // Convert string to Date
                  : this.props.case.createdOn, // Use as-is if it's already a Date
                this.props.currentLanguage
              )
            : ''
            }</BelfiusText>
        </div>
        <div className={`${styles.text} ${styles.visitDate}`}>
          <BelfiusText>{ 
            this.props.case.visitDate !== undefined
            ? this.localization.getFormatedDateTime(
                typeof this.props.case.visitDate === 'string'
                  ? new Date(this.props.case.visitDate) // Convert string to Date
                  : this.props.case.visitDate, // Use as-is if it's already a Date
                this.props.currentLanguage
              )
            : ''
            }</BelfiusText>
        </div>
        <div className={`${styles.text} ${styles.agendaReference}`}>
            <BelfiusText>{this.props.case.agendaReference}</BelfiusText>
        </div>
        {this.props.roles.includes(Role.AsUs) || ((this.props.roles.includes(Role.CoCaEx) || this.props.roles.includes(Role.CoCaIn)) && this.props.caseSearch.selectedPartyId > 0) ?
          <div className={`${styles.text} ${styles.expertName}`}>
            <BelfiusText>{this.props.case.expertName}</BelfiusText>
          </div> : ''}
        <div className={styles.actionBlock}>
          <div className={styles.actionRow}>
          {!this.props.case.blocked ?
            <BelfiusTooltip title={this.localization.get('home.refuse.tooltip')}>
              <img alt="" className={styles.actionIcon}
                onClick={() => this.props.refuseCaseOpen(this.props.case)}
                src={require('../../assets/images/web_refusal_75x75.png')} />
            </BelfiusTooltip>
            : '' }
            {this.props.roles.includes(Role.AsUs) && !this.props.case.blocked ?
              <BelfiusTooltip title={this.localization.get('home.assign.tooltip')}>
                <img alt="" className={styles.actionIcon}
                  onClick={() => this.props.assignUserOpen(this.props.case.claimNotificationId)}
                  src={this.props.case.assignedUserId > 0
                    ? require('../../assets/images/assign_selected_55x55.png')
                    : require('../../assets/images/assign_notselected_55x55.png')} />
              </BelfiusTooltip>
             : ''}
            {<BelfiusTooltip title={this.props.case.inProgress ?
                this.localization.get('home.inprogress.setfalse.tooltip')
                : this.localization.get('home.inprogress.settrue.tooltip')}>
                <img alt="" className={styles.actionIcon}
                onClick={() => this.props.setInProgressState(this.props.case)}
                src={this.props.case.inProgress
                  ? require('../../assets/images/prio_75x75_selected.png')
                  : require('../../assets/images/prio_75x75.png')} />
              </BelfiusTooltip>}
          </div>
          <div className={styles.actionRow}>
            {this.props.roles.includes(Role.ApAs) && !this.props.case.blocked ?
            <Link
              to={`/details/${this.props.case.instructionId}/#overview`}
              onClick={() => this.props.selectCase(this.props.case)}>
              <BelfiusTooltip title={this.localization.get('home.approve.tooltip')}>
                <img alt="" className={styles.actionIcon}
                  src={this.props.case.allApproved
                    ? require('../../assets/images/approve_green_55x55.png')
                    : this.props.case.anythingForApproval
                    ? require('../../assets/images/approve_selected_55x55.png')
                    : require('../../assets/images/approve_55x55.png')
                  } />
              </BelfiusTooltip>
            </Link>
              : ''}
            {this.props.roles.includes(Role.CrInIn) && !this.props.case.blocked ?
             <Link
                to={`/details/${this.props.case.instructionId}/#honorary_note`}
                onClick={() => this.props.selectCase(this.props.case)}>
                <BelfiusTooltip title={this.localization.get('home.honoraryNote.tooltip')}>
                <img alt="" className={styles.actionIcon}
                  src={this.props.case.allHnApproved
                    ? require('../../assets/images/honorary_green_55x55.png')
                    : this.props.case.anyHnForApproval
                    ? require('../../assets/images/honorary_selected_55x55.png')
                    : require('../../assets/images/honorary_55x55.png')}/>
                </BelfiusTooltip>
              </Link>
              : ''}
            {this.props.roles.includes(Role.ClCa) &&  !this.props.case.blocked ?
            <BelfiusTooltip title={this.props.case.archived ? this.localization.get('home.dearchive.tooltip') : this.localization.get('home.archive.tooltip')}>
              <img alt="" className={styles.actionIcon}
                onClick={() => this.props.archiveCaseOpen(this.props.case)}
                src={this.props.case.archived
                  ? require('../../assets/images/web_dearchive_75x75.png')
                  : require('../../assets/images/web_archive_75x75.png')} />
            </BelfiusTooltip>
            : ''}
          </div>
        </div>
        <div className={`${styles.text} ${styles.separator}`}>
            <span></span>
          </div>
      </div>
    );
  }
}

const mapStateToProps = ({ caseState, shared }: ApplicationState): PropsFromState => ({
  offlineCases: caseState.offlineCases,
  currentLanguage: shared.currentLanguage,
  roles: shared.roles,
  caseSearch: caseState.caseSearch
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  selectCase: (selectedCase: CaseResponse) => dispatch(selectCase(selectedCase)),
  refuseCaseOpen: (selectedCase: CaseResponse) => dispatch(refuseCaseOpen(selectedCase)),
  archiveCaseOpen: (selectedCase: CaseResponse) => dispatch(archiveCaseOpen(selectedCase)),
  assignUserOpen: (claimNotificationId: number) => dispatch(assignUserOpen(claimNotificationId)),
  setInProgressState: (selectedCase: CaseResponse) => dispatch(setInProgressState(selectedCase)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseDetails);
